import React from "react";

import {
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import ResumeScreeningCandidatesTableRow from "./ResumeScreeningCandidatesTableRow";
import { EmptyState, TableLoading } from "../../../common";
import { resume_canidates_table_columns } from "../../../static/table-columns";

const ResumeScreeningCandidatesTable = ({
  page,
  getData,
  tableData,
  isLoading,
  selectedRows,
  setSelectedRows,
  onRequestAssesment,
}) => {
  const isEmpty = tableData ? tableData?.length === 0 : false;

  return (
    <Card
      sx={{
        border: 1,
        mb: 1,
        overflow: "auto",
        borderColor: "#CFCFCF",
        height: { xs: "40%", sm: "55%", md: "65%", lg: "75%" },
        width: "100%",
        borderRadius: "12px",
      }}
    >
      <TableContainer
        sx={{
          maxHeight: "100%",
          maxWidth: "100%",
          fontFamily: "Outfit",
          overflow: "auto",
          "& .MuiTableRow-root:hover": { backgroundColor: "primary.200" },
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {resume_canidates_table_columns?.map((column, i) => (
                <TableCell
                  key={column.id}
                  align="left"
                  sx={{
                    minWidth: i === 0 ? "20px" : "200px",
                    bgcolor: "white",
                  }}
                >
                  {column.label ? (
                    <Typography
                      fontSize={{ xs: "14px", md: "16px" }}
                      fontWeight={600}
                      color="#21282F"
                    >
                      {column.label}
                    </Typography>
                  ) : (
                    <Checkbox
                      checked={selectedRows === "all"}
                      onChange={(e) =>
                        setSelectedRows(e.target.checked ? "all" : [])
                      }
                    />
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {isLoading ? (
              <TableLoading noOfColumns={6} />
            ) : (
              tableData?.map((id) => (
                <ResumeScreeningCandidatesTableRow
                  key={id}
                  id={id}
                  getData={getData}
                  page={page}
                  selectedRows={selectedRows}
                  onRequestAssesment={onRequestAssesment}
                  setSelectedRows={setSelectedRows}
                />
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {isEmpty && !isLoading && (
        <EmptyState
          title="Looks like there's no resumes found. Try adjusting your filters"
          top={"20%"}
        />
      )}
    </Card>
  );
};

export default ResumeScreeningCandidatesTable;
